export enum RoleEnum {
    // PUBLIC_USER,
    INTERNAL_USER,
    MANAGER,
    ADMIN,
    DASHBOARD,
    CSR,
    SUPERVISOR
}
export namespace RoleEnum {
    export function keys(): Array<string>{
      var keys = Object.keys(RoleEnum);
      return keys.slice(keys.length / 2, keys.length-1);
    }
  }